<mat-card class="mat-elevation-z4 card"
  [class.selected]="selected"
  (contextmenu)="handleContextMenu($event)"
  cdkOverlayOrigin #trigger="cdkOverlayOrigin"

>
  <div class="folder-image" (click)="previewFile(sheet)" >
    <mat-icon [inline]="true">{{ type === 'file' ? 'picture_as_pdf': 'folder'}}</mat-icon>
  </div>
  <mat-card-content>
    @if(type === 'file') {
      <p noWrap>id: {{ id }}</p>
    }
    <p class="mat-line">{{ name }}</p>
  </mat-card-content>
  @if(type === 'file' ) {

    <cdk-accordion class="example-accordion">
      <cdk-accordion-item
        #accordionItem="cdkAccordionItem"
        class="example-accordion-item"
        role="button"
        tabindex="0"
        [attr.id]="'accordion-header-' + 0"
        [attr.aria-expanded]="accordionItem.expanded"
        [attr.aria-controls]="'accordion-body-' + 0">
        <div class="example-accordion-item-header" (click)="accordionItem.toggle()">
          Metadaten
          <span class="example-accordion-item-description">
            <mat-icon>{{ accordionItem.expanded ? 'expand_more' : 'expand_less' }}</mat-icon>
          </span>
        </div>
        <div
          class="example-accordion-item-body"
          role="region"
          [style.display]="accordionItem.expanded ? '' : 'none'"
          [attr.id]="'accordion-body-' + 0"
          [attr.aria-labelledby]="'accordion-header-' + 0">
          <app-musician-auto-input [musicianid]="authorid" (musicianChanged)="changeAuthor(sheet, $event)"></app-musician-auto-input>
          <mat-form-field style="zoom: 0.85;">
            <mat-label>Datum</mat-label>
            <input matInput [matDatepicker]="recpicker" [(ngModel)]="date" (dateChange)="dateChanged(sheet, $event)">
            <!--<input matInput [matDatepicker]="recpicker">-->
            <mat-hint>MM.DD.YYYY</mat-hint>
            <mat-datepicker-toggle matIconSuffix [for]="recpicker"></mat-datepicker-toggle>
            <mat-datepicker #recpicker></mat-datepicker>
          </mat-form-field>
          <mat-form-field appearance="fill">
            <mat-label>Typ</mat-label>
            <mat-select [(value)]="sheetTypeID">
              <mat-option *ngFor="let type of sheetTypes" [value]="type.id" (onSelectionChange)="updateType(sheet, type.id)">
                {{ type.designation }}
              </mat-option>
            </mat-select>
          </mat-form-field>

        </div>
      </cdk-accordion-item>
    </cdk-accordion>
    <mat-card-actions align="end">
      @if(mode === 'edit' ) {
        <button mat-button color="warn" (click)="removeSheet(sheet)">Löschen</button>
      }
      @else {
        <button mat-button color="primary" (click)="assignSheet(sheet)">Zuweisen</button>
      }
    </mat-card-actions>
  }


  <ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="trigger"
    [cdkConnectedOverlayOpen]="ctxMenuOpened">
  <ul class="overlay-menu" #overlayTemplate>
    @if(type==='file') {
      <li (click)="menuAction()">File 1</li>
      <li (click)="menuAction()">File 2</li>
      <li (click)="menuAction()">File 3</li>
    }
    @else if(type==='folder') {
      <li (click)="menuAction()">Folder 1</li>
      <li (click)="menuAction()">Folder 2</li>
      <li (click)="menuAction()">Folder 3</li>
    }
  </ul>
  </ng-template>
</mat-card>
